import PropTypes from 'prop-types';
import { createContext, useCallback, useContext, useState, useRef, useEffect } from 'react';
import { DataContext } from "../DataProviders/DataProvider"
import { useStepwiseStorage } from '../../hooks/useStepwiseStorage';
import { DomainContext } from '../AutomationProvider/DomainProvider';
import API from '../../axios/API';
import { subscriptionAPI } from '@/api';

const ManualOrderContext = createContext();

const ManualOrderProvider = ({ children }) => {
    const { orgName, orderId, isTimezoneAvailabe, userId, loginCustomerId, setOrderNumber, setOrderId, orderNumber, customerId, userRole } = useContext(DataContext);
    const [loading, setLoading] = useState(true);
    const { saveStepData, getStepData } = useStepwiseStorage();
    const [domains, setDomains] = useState([]);


    // useEffect(() => {
    //     setOrderNumber()
    // }, [])
    const [data, setData] = useState()

    const [paypalResponseData, setPaypalResponseData] = useState('');

    const [emails, setEmails] = useState([]); // State for emails
    const [organizationName, setOrganizationName] = useState("");
    const [error, setError] = useState("");

    // File upload state to persist across step changes
    const [fileToUpload, setFileToUpload] = useState(null);
    const [fileName, setFileName] = useState("No selected file");
    const [isOrgNameSubmitted, setIsOrgNameSubmitted] = useState(false);

    // Email provider state to persist across step changes
    const [showEmailProviderModal, setShowEmailProviderModal] = useState(true);
    const [selectedEmailProvider, setSelectedEmailProvider] = useState("");

    // New state to track if user clicked "Proceed to checkout" button
    const [hasClickedCheckout, setHasClickedCheckout] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false);

    const {
        domainEmailAccountData,
        setDomainEmailAccount,
    } = useContext(DomainContext);

    useEffect(() => {
        // Initialize form values from domainEmailAccountData 
        setDomainEmailAccount({
            forwardDomain: '',
            recoveryEmail: '',
            accessMethod: '',
            loginUrl: '',
            userName: '',
            password: '',
            domainCount: '',
            confirmAccess: ""
        })
    }, [])

    const [formValues, setFormValues] = useState({
        forwardDomain: domainEmailAccountData?.forwardDomain || '',
        recoveryEmail: domainEmailAccountData?.recoveryEmail || '',
        accessMethod: domainEmailAccountData?.accessMethod || 'delegate',
        loginUrl: domainEmailAccountData?.loginUrl || '',
        userName: domainEmailAccountData?.userName || '',
        password: domainEmailAccountData?.password || '',
        confirmAccess: domainEmailAccountData?.confirmAccess || false,
        // Domain registrar fields
        domainAccessMethod: 'delegate',
        domainLoginUrl: '',
        domainUsername: '',
        domainConfirmAccess: false
    });

    // State for selected registrar credential when "connect" option is used
    const [selectedRegistrarCredential, setSelectedRegistrarCredential] = useState('none');
    const [loadingRegistrarCredentials, setLoadingRegistrarCredentials] = useState(false);
    const [checkingDomainSupport, setCheckingDomainSupport] = useState(false);
    const [userPaymentGateway, setUserPaymentGateway] = useState();


    // State for storing email accounts data
    const [emailAccountsData, setEmailAccountsData] = useState([]);

    // State for storing form data from EmailAccounts component
    const [emailFormData, setEmailFormData] = useState({});

    // Helper to calculate initial step: if user used browser 'back' from a payment gateway, start fresh at step 0
    const getInitialStep = () => {
        try {
            const isBackNavigation = performance.getEntriesByType("navigation").some((nav) => nav.type === "back_forward");
            if (isBackNavigation) {
                return 0; // Force to step 1 on back navigation
            }
        } catch (e) {
            // fallback for missing performance API support
        }
        return localStorage.getItem("activeStep") ? parseInt(localStorage.getItem("activeStep")) : 0;
    };

    // State for managing active step
    const [activeStep, setActiveStep] = useState(getInitialStep());

    // Upon mount, if it was a back navigation, ensure all stale order states are cleared.
    useEffect(() => {
        try {
            const isBackNavigation = performance.getEntriesByType("navigation").some((nav) => nav.type === "back_forward");
            if (isBackNavigation) {
                setOrderNumber("");
                setOrderId("");
                sessionStorage.removeItem("selectedOrderNo");
                sessionStorage.removeItem("selectedOrderId");
                localStorage.setItem("activeStep", 0);

                // Clear all manual order contextual data
                setEmails([]);
                setDomains([]);
                setOrganizationName("");
                setSelectedEmailProvider("");
                setSelectedRegistrarCredential('none');
                setIsBulkOrder(false);
                setEmailAccountsData([]);
                setEmailFormData({});
                setFormValues({
                    forwardDomain: '',
                    recoveryEmail: '',
                    accessMethod: 'delegate',
                    loginUrl: '',
                    userName: '',
                    password: '',
                    confirmAccess: false,
                    domainAccessMethod: 'delegate',
                    domainLoginUrl: '',
                    domainUsername: '',
                    domainPassword: '',
                    domainConfirmAccess: false,
                    domainProviderCredentialNumber: null,
                });
            }
        } catch (e) {
            console.error(e);
        }
    }, [setOrderId, setOrderNumber]);
    const [isBulkOrder, setIsBulkOrder] = useState(false);

    // Ref to store the latest data (to avoid stale closure issues)
    const latestDataRef = useRef({
        emailFormData: {},
        emailAccountsData: []
    });

    // Update refs whenever state changes
    const updateEmailFormData = useCallback((data) => {
        setEmailFormData(data);
        latestDataRef.current.emailFormData = data;
    }, []);

    const updateEmailAccountsData = useCallback((data) => {
        setEmailAccountsData(data);
        latestDataRef.current.emailAccountsData = data;
    }, []);

    // Function to register step-specific actions
    const registerStepAction = () => {
    };

    // Function to handle click on step
    const handleStepClick = (step) => {
        const isOrderIdValid =
            orderId !== null && orderId !== undefined && orderId.trim() !== "";

        let canProceed = false;
        switch (step) {
            case 0:
                canProceed = true;
                break;
            case 1:
            case 2:
                canProceed = isOrderIdValid;
                break;
            case 3:
                canProceed = isTimezoneAvailabe;
                break;
            default:
                canProceed = false;
        }

        if (canProceed) {
            setActiveStep(step);
            window.scrollTo(0, 0); // Scroll to top of the page after clicking on a step
        }
    };

    const handleNext = async () => {
        if (organizationName === "") {
            setError("Organization name is required");
            return;
        }

        const data = {
            organizationName,
            domains,
            fileName,
            isOrgNameSubmitted,
            selectedEmailProvider,
            showEmailProviderModal
        }
        // console.log(data)
        saveStepData(1, data, loginCustomerId)
        setActiveStep(localStorage.setItem("activeStep", 1) ? parseInt(localStorage.getItem("activeStep")) : 1);
    }

    const handleNext2 = async () => {
        setActiveStep(localStorage.setItem("activeStep", 2) ? parseInt(localStorage.getItem("activeStep")) : 2);
        setLoading(true);
        const stepOneData = await getStepData(1, loginCustomerId)

        try {
            // Merge emailFormData with formValues to include domainProviderCredentialNumber
            const mergedFormData = {
                ...formValues,
                ...emailFormData
            };

            // If domainAccessMethod is 'connect' and selectedRegistrarCredential is set, ensure domainProviderCredentialNumber is included
            if (mergedFormData.domainAccessMethod === 'connect' && selectedRegistrarCredential && selectedRegistrarCredential !== 'none') {
                mergedFormData.domainProviderCredentialNumber = Number(selectedRegistrarCredential);
            }

            const dataToSave = {
                formData: mergedFormData,
                emailAccounts: emails,
                // Additional metadata
                timestamp: new Date().toISOString(),
                orderId: orderId,
                userId: loginCustomerId,
                orgName: orgName,
            };

            // Save the data using step 2 (fire-and-forget; we use dataToSave directly below)
            saveStepData(2, dataToSave, loginCustomerId);

            // Use dataToSave directly — getStepData can return null immediately after save
            const stepTwoData = { data: dataToSave };

            // Resolve emailProvider from localStorage (set by SelectPlanModal)
            const resolvedEmailProvider = (() => {
                try {
                    const selectedPlan = JSON.parse(localStorage.getItem("selectedPlan") || "{}");
                    if (selectedPlan.provider === "microsoft") return "Microsoft 365";
                    if (selectedPlan.provider === "google") return "Google Workspace";
                } catch { /* ignore */ }
                // fallback: the "provider" key stores the display name directly
                return localStorage.getItem("provider") || "";
            })();

            const seenDomains = new Set();
            const emailAccounts = stepTwoData.data.emailAccounts.map((email) => {
                const domain = email.domain;
                const isWorkspaceAdmin = !seenDomains.has(domain);
                if (isWorkspaceAdmin) {
                    seenDomains.add(domain);
                }

                return {
                    domain: domain,
                    email: email.email.toLowerCase(),
                    emailProvider: email.emailProvider || resolvedEmailProvider,
                    firstName: email.firstName,
                    fullName: email.fullName,
                    lastName: email.lastName,
                    profilePicture: email.profilePicture || "",
                    password: email.password || "",
                    isWorkspaceAdmin: isWorkspaceAdmin
                }
            }) || [];

            setActiveStep(2);

            // Scroll to top
            window.scrollTo(0, 0);

            const payload = {
                userId: userId,
                customerId: userRole === "ADMIN" ? customerId : loginCustomerId,
                orderId: orderId ? orderId : null,
                orderNumber: orderNumber ? orderNumber : null,
                organisationName: organizationName || stepOneData?.data?.organizationName,
                generalInformation: {
                    forwardingDomain: stepTwoData.data.formData.forwardDomain,
                    recoveryEmail: stepTwoData.data.formData.recoveryEmail,
                },
                emailTool: {
                    loginURL: stepTwoData.data.formData.loginUrl || null,
                    username: stepTwoData.data.formData.userName || null,
                    password: stepTwoData.data.formData.accessMethod === 'login' ? (stepTwoData.data.formData.password || null) : null,
                    workspace: "Yes",
                    email: stepTwoData.data.formData.recoveryEmail,
                    shareAccessConfirmation: stepTwoData.data.formData.accessMethod === 'login',
                    delegateAccessConfirmation: stepTwoData.data.formData.accessMethod === 'delegate' && stepTwoData.data.formData.confirmAccess,
                },
                domainRegistrar: stepTwoData.data.formData.domainProviderCredentialNumber ? null : {
                    loginURL: stepTwoData.data.formData.domainLoginUrl || null,
                    username: stepTwoData.data.formData.domainUsername || null,
                    password: stepTwoData.data.formData.domainAccessMethod === 'share' ? (stepTwoData.data.formData.domainPassword || null) : null,
                    workspace: "Yes",
                    email: stepTwoData.data.formData.recoveryEmail,
                    shareAccessConfirmation: stepTwoData.data.formData.domainAccessMethod === 'share',
                    delegateAccessConfirmation: stepTwoData.data.formData.domainAccessMethod === 'delegate' && stepTwoData.data.formData.domainConfirmAccess,
                },
                emailAccounts,
                domainProviderCredentialNumber: stepTwoData.data.formData.domainProviderCredentialNumber || null
            }

            const response = await API.post(`${import.meta.env.VITE_BACKEND_API}/create-an-order?orderSource=NEW_ORDER`, payload);

            const orderDerails = response.data.data;

            setOrderId(orderDerails.orderId);
            setOrderNumber(orderDerails.orderNumber);
            await subscriptionAPI(orderDerails.orderId);
            // Resolve User Payment Gateway
            const resolvePayload = {
                customerId: userRole === "ADMIN" ? customerId : loginCustomerId,
                userId: userId,
                orderNumber: Number(orderDerails.orderNumber),
                orderId: orderDerails.orderId,
                currentMonthAmount: 0,
                recurringAmount: 0,
            };

            let paymentGatewayData = null;
            try {
                const gatewayResponse = await API.post(
                    `${import.meta.env.VITE_BACKEND_API}/resolve-user-payment-gateway`,
                    resolvePayload
                );

                if (gatewayResponse.status === 200) {
                    setUserPaymentGateway(gatewayResponse.data.paymentGateway);
                    paymentGatewayData = gatewayResponse.data;
                }
            } catch (error) {
                console.error("Error resolving payment gateway:", error);
            }

            const requestPayload = {
                orderId: orderDerails.orderId,
                userId,
                orderNumber: Number(orderDerails.orderNumber),
                customerId: userRole === "ADMIN" ? customerId : loginCustomerId,
            };

            // API request
            let list = await API.post(
                `${import.meta.env.VITE_BACKEND_API}/billinglist?orderType=NEW_ORDER`,
                requestPayload
            );

            const result = list.data[0];
            setData(result);
            setLoading(false);
        } catch (error) {
            console.error('Error in handleNext2:', error);
            return false;
        }
    }



    // Function to get current step data (useful for debugging)
    const getCurrentStepData = useCallback(() => {
        return {
            formData: latestDataRef.current.emailFormData,
            emailAccounts: latestDataRef.current.emailAccountsData,
            activeStep,
            orderId,
            userId
        };
    }, [activeStep, orderId, userId]);

    // Function to handle back button click
    const handleBack = () => {
        const prevStep = activeStep - 1;
        if (prevStep >= 0) {
            setActiveStep(prevStep);
            window.scrollTo(0, 0); // Scroll to top of the page after clicking on back
        }
    };

    // Effect to fetch order data on reload if in the checkout step
    useEffect(() => {
        const resumeCheckout = async () => {
            // Only resume if on step 2 (Checkout), no data is present, and we have an order record
            if (activeStep === 2 && !data && orderId && orderNumber) {
                setLoading(true);
                try {
                    const requestPayload = {
                        orderId,
                        userId,
                        orderNumber: typeof orderNumber === 'string'
                            ? parseInt(orderNumber.replace('INB', '').trim(), 10)
                            : Number(orderNumber),
                        customerId: userRole === "ADMIN" ? "" : loginCustomerId, // Using loginCustomerId safely
                    };

                    const response = await API.post(
                        `${import.meta.env.VITE_BACKEND_API}/billinglist?orderType=NEW_ORDER`,
                        requestPayload
                    );

                    if (response.data && response.data.length > 0) {
                        setData(response.data[0]);
                    }
                } catch (err) {
                    console.error("Error resuming checkout data:", err);
                } finally {
                    setLoading(false);
                }
            } else if (activeStep !== 2) {
                setLoading(false); // Ensure loading is off for non-checkout steps on mount/reload
            }
        };

        resumeCheckout();
    }, [activeStep, orderId, orderNumber, data, userId, loginCustomerId, userRole]);

    return (
        <ManualOrderContext.Provider
            value={{
                activeStep,
                handleStepClick,
                handleNext,
                handleNext2, // Enhanced function
                handleBack,
                registerStepAction,
                setDomains,
                domains,
                // Updated state and setters for email accounts data
                emailAccountsData,
                setEmailAccountsData: updateEmailAccountsData, // Use the wrapper function
                emailFormData,
                setEmailFormData: updateEmailFormData, // Use the wrapper function
                // Additional utilities
                getCurrentStepData,
                setFormValues,
                formValues,
                setEmails, emails,
                setOrganizationName,
                organizationName,
                loading,
                setLoading,
                error,
                setError,
                setData,
                data,
                setPaypalResponseData,
                paypalResponseData,
                setActiveStep,
                // New state and setter for checkout button tracking
                hasClickedCheckout,
                setHasClickedCheckout,
                isFormValid,
                setIsFormValid,
                // File upload state
                fileToUpload,
                setFileToUpload,
                fileName,
                setFileName,
                isOrgNameSubmitted,
                setIsOrgNameSubmitted,
                // Email provider state
                showEmailProviderModal,
                setShowEmailProviderModal,
                selectedEmailProvider,
                setSelectedEmailProvider,
                isBulkOrder,
                setIsBulkOrder,
                // Registrar credential state
                selectedRegistrarCredential,
                setSelectedRegistrarCredential,
                loadingRegistrarCredentials,
                setLoadingRegistrarCredentials,
                checkingDomainSupport,
                setCheckingDomainSupport,
                userPaymentGateway,
                setUserPaymentGateway,
            }}
        >
            {children}
        </ManualOrderContext.Provider>
    );
};

ManualOrderProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export { ManualOrderContext, ManualOrderProvider };